import React from "react";
import MightyInput from "mighty-input";

import "./style.css";

export function PhoneNumber({ value = "", ...props }) {
  // Fix value
  const filter = (next, prev) => (/^\+?[^0-9-()]/.test(next) ? next : prev);

  // Render unprinted part of value in other colour
  const render = next =>
    Array.from(next).map((char, i) => {
      if (/\d/.test(char)) {
        return char;
      } else {
        return (
          <span key={i} className="phoneNumber-delim">
            {char}
          </span>
        );
      }
    });

  return (
    <MightyInput
      value={value}
      className="myInput"
      filter={filter}
      render={render}
      {...props}
    />
  );
}
